import axios from "axios";
import { handleAxiosErrors, getRessource } from "../utils";

const COMMUNE = "/commune";
const GET_COMMUNE_ZA = `${COMMUNE}/get-communeza`;
const GET_COMMUNES_RESEAU = `${COMMUNE}/get-communes-by-codesReseau`;
const GET_VOIES_OF_COMMUNE = `${COMMUNE}/get-voies-of-commune`;
const GET_NUMEROS_OF_VOIE = `${COMMUNE}/get-numeros-of-voie`;

export const getCommuneZa = (codeINSEE, abort) =>
  axios
    .get(GET_COMMUNE_ZA, {
      params: {
        codeINSEE,
      },
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));

export const getCommunesByCodesReseau = (codesReseau, abort) =>
  axios
    .get(GET_COMMUNES_RESEAU, {
      params: {
        codesReseau,
      },
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));

export const getVoiesOfCommune = (codeInsee, codePostal, abort) =>
  axios
    .get(GET_VOIES_OF_COMMUNE, {
      params: {
        codeInsee,
        codePostal,
      },
      signal: abort.signal,
    })
    .then(response => response.data)
    .catch(error => Promise.reject(error));

export const getNumerosOfVoie = ({ referenceVoieOI, libelleVoieOI, codeInsee, abort }) =>
  axios
    .get(GET_NUMEROS_OF_VOIE, {
      params: {
        referenceVoieOI,
        libelleVoieOI,
        codeInsee,
      },
      signal: abort.signal,
    })
    .then(response => response.data)
    .catch(error => Promise.reject(error));
